import { type QuestionsProps } from "@/features/questionnaire/types";
import { NumberField } from "@repo/ui";

export const NumberQuestion = ({
  answer,
  onFreeTextAnswered,
}: QuestionsProps) => {
  return (
    <NumberField
      id="questionnaire-number"
      value={answer?.answerFreeText ?? undefined}
      onChange={(e) => {
        onFreeTextAnswered?.(e);
      }}
    />
  );
};
